import { useRef } from "react";
import { Link } from "react-router-dom";

import LootiePresentation from "../../lotties/LootiePresentation";

import "./style.css"

import spacenaute from './../../assets/img/spacenaute_png.png'

import svg_skills_0 from './../../assets/svg/svg_skills_0.svg'
import svg_skills_1 from './../../assets/svg/svg_skills_1.svg'
import svg_skills_2 from './../../assets/svg/svg_skills_2.svg'

import icon_benefits_0 from './../../assets/img/icon_benefits_0.png'
import icon_benefits_1 from './../../assets/img/icon_benefits_1.png'
import icon_benefits_2 from './../../assets/img/icon_benefits_2.png'

function Home() {
    const skillsRef = useRef(null);
    const benefitsRef = useRef(null);

    return (
        <div className="page page_home">
            <section className="sct_presentation">
                <div className="rocket_anim">
                    <LootiePresentation />
                </div>

                <div className="main_menu">
                    <div className="title">
                        <img src={spacenaute} alt=" " />
                        <h1>Création de Site <br /> Internet</h1>
                    </div>

                    <span className='subTitle second_color'>Découvrir l’éventail de nos services mis à votre disposition pour créer le site dont vous avez besoin.</span>

                    <p className='text'>Nous vous apporterons des solutions adaptées en matière de webdesign et de technologie web pour répondre à vos besoins et vous aider à
                        faire décoller votre entreprise. Nos compétences en création de site internet sont variées, que vous souhaitiez développer votre notoriété,
                        générer des prospects en ligne, notre agence web vous accompagne dans la création ou la refonte de votre site internet sur mesure.</p>

                    <ul className='main_menu_list'>
                        <li className='link_anime_1'><Link to='/form_static'>Créer un site vitrine / blog</Link></li>
                        <li className='link_anime_2'><Link to='/form_e-commerce'>Créer un site e-commerce</Link></li>
                        <li className='link_anime_3'><Link to='/form_refont'>Refonte d’un site internet</Link></li>
                    </ul>
                </div>
            </section>

            <section ref={skillsRef} className='sct_skills'>
                <ul className='skill_list'>
                    <li>
                        <img src={svg_skills_0} alt=" " />

                        <div className='skill'>
                            <h2>Notre Savoir-Faire en Création de Sites Internet</h2>
                            <p>Notre équipe de développeurs maîtrise une large gamme d'outils pour répondre à vos besoins, incluant HTML/CSS, JavaScript,
                                React, Express, MongoDb, et bien d'autres. Centré sur l'Expérience Utilisateur (UX) nous mettons tout en œuvre pour valoriser
                                votre image tout en promouvant efficacement vos produits ou services.</p>
                        </div>
                    </li>

                    <li>
                        <img src={svg_skills_1} alt=" " />

                        <div className='skill'>
                            <h2>Tests Rigoureux pour un Site Performant</h2>
                            <p>Ces tests approfondis visent à prévenir les nécessités de refonte dans le futur, garantissant la création d'un site fonctionnel,
                                ergonomique, et doté d'une interface intuitive. Notre objectif est de créer une plateforme web qui répond non seulement à vos attentes,
                                mais qui satisfasse pleinement celles de vos utilisateurs.</p>
                        </div>
                    </li>

                    <li>
                        <img src={svg_skills_2} alt=" " />

                        <div className='skill'>
                            <h2>Satisfaction et Engagement des Utilisateurs</h2>
                            <p>Enfin nous visons à générer un sentiment de satisfaction lors des visites de vos internautes. Cette satisfaction constitue le premier
                                pas vers l'établissement d'une notoriété web solide. Nous accordons une attention particulière à la phase d'étude lors de la
                                création de sites web. Cela garantit non seulement un site performant, mais également à la hauteur de vos objectifs.</p>
                        </div>
                    </li>
                </ul>
            </section>

            <section ref={benefitsRef} className='sct_benefits'>
                <p className='text'>À l’heure actuelle il existe beaucoup de différents moyens pour créer un site internet à moindre coût : éditeur de site, CMS avec
                    template, freelance… Mais allez-vous réellement refléter vos valeurs et votre identité à travers votre site web ?</p>

                <ul className='benefits_list'>
                    <li>
                        <img src={icon_benefits_0} alt=" " />
                        <p>En choisissant notre équipe pour la création de votre site, vous optez pour une combinaison unique d'expertise technique, un design entièrement
                            personnalisé et centré sur l'utilisateur, </p>
                    </li>

                    <li>
                        <img src={icon_benefits_1} alt=" " />
                        <p>Une approche stratégique qui garantira le succès continu de votre présence en ligne ainsi qu’un suivi clair lors du développement de votre site</p>
                    </li>

                    <li>
                        <img src={icon_benefits_2} alt=" " />
                        <p>De plus, grâce à notre service MySpace vous pourrez éditer à n’importe quel moment les données de votre site de manière simple et intuitive.</p>
                    </li>
                </ul>
            </section>
        </div>
    );
}

export default Home;